exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".overlay-fixed{display:block;width:100%;height:100%;position:fixed;top:0;left:0;background-color:rgba(0,0,0,.8);text-align:center}.overlay-fixed .dialog{display:block;width:500px;height:300px;background-color:#fff;margin:200px auto;text-align:center}.overlay-fixed .dialog>textarea{margin:1em;width:468px;height:218px;padding:1em;line-height:1.5;border:1px solid #eee;outline:none}.overlay-fixed .dialog>textarea:focus{border-color:#ccc}.overlay-fixed .dialog .footer{border-top:1px solid #ccc;width:100%;height:50px;line-height:50px;padding:0 1em;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/stylus-loader!./ui/textfield-modal/styles.styl
// module id = 952
// module chunks = 0